import { render, staticRenderFns } from "./des-stu.vue?vue&type=template&id=81c37826&"
import script from "./des-stu.vue?vue&type=script&lang=js&"
export * from "./des-stu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports